export const UNIT_TO_SECONDS = { Minutes: 60, Hours: 3600, Days: 86400 };

export const secondsToTimeUnit = seconds => {
  if (seconds === null || seconds === undefined) {
    return { time: null, unit: 'Minutes' };
  }
  if (seconds % UNIT_TO_SECONDS.Days === 0) {
    return { time: seconds / UNIT_TO_SECONDS.Days, unit: 'Days' };
  }
  if (seconds % UNIT_TO_SECONDS.Hours === 0) {
    return { time: seconds / UNIT_TO_SECONDS.Hours, unit: 'Hours' };
  }
  return { time: seconds / UNIT_TO_SECONDS.Minutes, unit: 'Minutes' };
};

export const convertToSeconds = (threshold, unit) => {
  if (threshold === null || threshold === undefined || threshold === 0) {
    return null;
  }
  return Number(threshold * (UNIT_TO_SECONDS[unit] || 1));
};

const DISPLAY_UNIT_TO_SECONDS = { day: 86400, hour: 3600, minute: 60 };

export const displayTime = seconds => {
  if (!seconds) return '-';
  if (seconds % DISPLAY_UNIT_TO_SECONDS.day === 0) {
    return `${seconds / DISPLAY_UNIT_TO_SECONDS.day}d`;
  }
  if (seconds % DISPLAY_UNIT_TO_SECONDS.hour === 0) {
    return `${seconds / DISPLAY_UNIT_TO_SECONDS.hour}h`;
  }
  return `${seconds / DISPLAY_UNIT_TO_SECONDS.minute}m`;
};

// `@chatwoot/utils`'s `formatTime` hardcodes its unit abbreviations ("Sec"/"Min"/"Hr"/"Day")
// in English with no locale support, so it leaks English text into non-English UI (e.g. "Sec"
// shows up even when the app locale is pt_BR). This mirrors its exact thresholds/logic but
// sources the unit abbreviations from i18n, via the `CUSTOM_SLA.DURATION_UNITS` keys — callers
// pass their own `t`/`$t` since this is a plain helper, not a composable.
export const formatCustomSlaDuration = (timeInSeconds, t) => {
  const second = t('CUSTOM_SLA.DURATION_UNITS.SECOND');
  const minute = t('CUSTOM_SLA.DURATION_UNITS.MINUTE');
  const hour = t('CUSTOM_SLA.DURATION_UNITS.HOUR');
  const day = t('CUSTOM_SLA.DURATION_UNITS.DAY');

  if (timeInSeconds >= 60 && timeInSeconds < 3600) {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = minutes === 60 ? 0 : Math.floor(timeInSeconds % 60);
    return `${minutes} ${minute}${seconds > 0 ? ` ${seconds} ${second}` : ''}`;
  }

  if (timeInSeconds >= 3600 && timeInSeconds < 86400) {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes =
      timeInSeconds % 3600 < 60 || hours === 24
        ? 0
        : Math.floor((timeInSeconds % 3600) / 60);
    return `${hours} ${hour}${minutes > 0 ? ` ${minutes} ${minute}` : ''}`;
  }

  if (timeInSeconds >= 86400) {
    const days = Math.floor(timeInSeconds / 86400);
    const hours =
      timeInSeconds % 86400 < 3600 || days >= 364
        ? 0
        : Math.floor((timeInSeconds % 86400) / 3600);
    return `${days} ${day}${hours > 0 ? ` ${hours} ${hour}` : ''}`;
  }

  return `${Math.floor(timeInSeconds)} ${second}`;
};
